import officialAccount from './officialAccount'
import sweepCode from './sweepCode'
import invoice from './invoice'

export const officialAccountRequest = officialAccount.request
export const sweepCodeRequest = sweepCode.request
export const invoiceRequest = invoice.request
